import { createContext, useContext } from 'react';

import { CompanySettings } from 'common/hooks/useCompanySettings';
import { FormClient, FormCompany } from 'features/Work/types';

import { MINIMUM_LATE_FEE_FALLBACK } from '../../../../constants';
import { defaultCompany } from './constants';

export type QuoteFormContextType = {
  company: FormCompany;
  companySettings?: CompanySettings;
  clients: FormClient[];
  metadata: QuoteFormMetadata;
  isEditMode: boolean;
};

export type QuoteFormMetadata = {
  minLatePaymentFee: number;
};

export const QuoteFormContext = createContext<QuoteFormContextType>({
  clients: [],
  company: defaultCompany,
  isEditMode: false,
  metadata: {
    minLatePaymentFee: MINIMUM_LATE_FEE_FALLBACK,
  },
});

export const QuoteFormContextProvider = QuoteFormContext.Provider;

export const useQuoteFormContext = () => {
  const context = useContext(QuoteFormContext);

  if (!context) {
    throw new Error(
      'useQuoteFormContext must be used within a QuoteFormContextProvider',
    );
  }

  return context;
};
